import { StoreActionLoggableName } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { addAssistantMessage } from './addAssistantMessage';
import { addHumanMessage } from './addHumanMessage';
import { clearFollowUpMessages } from './clearFollowUpMessages';
import { createConversationOptimistically } from './createConversationOptimistically';
import { createSafeAction, type SafeAction } from './createSafeAction';
import { getSendMessageExperienceName } from './getSendMessageExperienceName';
import { reconnectToInProgressStream } from './reconnectToInProgressStream';
import { sendMessageActionProvider } from './sendMessageActionProvider';
import { type SendMessageConsumerPramas } from './sendMessageActionTypes';
import { setConversationData } from './setConversationData';
import { setSelectedConversation } from './setSelectedConversation';
import type { ChatStoreAction } from './types';

/**
 * Send a message to the assistant and add it to react-sweet-state
 *
 * @param agentId -- this parameter will be prioritised over agent.id
 */
export const sendMessage: SafeAction<[SendMessageConsumerPramas]> = createSafeAction(
	StoreActionLoggableName.sendMessage,
	(props: SendMessageConsumerPramas): ChatStoreAction =>
		sendMessageActionProvider({
			...props,
			setConversationData,
			createConversationOptimistically,
			addHumanMessage,
			addAssistantMessage,
			clearFollowUpMessages,
			setSelectedConversation,
			reconnectToInProgressStream,
		}),
	{
		experienceName: (args) =>
			getSendMessageExperienceName({
				deepResearchEnabled: args[0]?.deepResearchEnabled,
				thinkDeeperEnabled: args[0]?.thinkDeeperEnabled,
				taskModeEnabled: args[0]?.taskModeEnabled,
				fastModeEnabled: args[0]?.fastModeEnabled,
			}),
		getRateLimitState: (args) => ({
			isDeepResearchAttempt: args[0]?.deepResearchEnabled,
		}),
	},
);
